import loadableWithRetry from '../common/loadableWithRetry'

const AddToWishList = loadableWithRetry(() => import('./AddToWishList'))

export default AddToWishList;

